import { Button } from "@mui/material";
import React from "react";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import Grid from "@mui/material/Unstable_Grid2";
export default function ChangePassword() {
  const [oldPassword, setOldPassword] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };
  return (
    <Grid container spacing={3}>
      <Grid xs={12}>
        <h3 className="mb-0">Create New Password</h3>
      </Grid>
      <Grid xs={12} sx={{ paddingLeft: "0px" }}>
        <Grid container spacing={3}>
          <Grid md={6} lg={3}>
            <RKTextField
              class_name="inputField mb-5"
              title="Old Password"
              value={oldPassword}
              attrName={setOldPassword}
              value_update={updateMasterState}
              warn_status={false}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid md={6} lg={3} className="inputField mb-5">
            <RKTextField
              class_name="inputField"
              title="New Password"
              value={newPassword}
              attrName={setNewPassword}
              value_update={updateMasterState}
              warn_status={false}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid md={6} lg={3} className="inputField mb-5">
            <RKTextField
              class_name="inputField"
              title="Confirm New Password"
              value={confirmPassword}
              attrName={setConfirmPassword}
              value_update={updateMasterState}
              warn_status={false}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid xs={12} className="ctaBtn mb-5">
            <Button className="submitBtn">Submit</Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
